import React, { useEffect } from 'react';

import { Button } from '@spotahome/ui-library';

import { trans, getPagePath } from '@spotahome/soyuz/client';
import Metrics from '@spotahome/soyuz-metrics';

import './Final.scss';

const Final = () => {
  useEffect(() => {
    Metrics.ga.sendEvent('Matcher', 'Final', 'pageview');
  }, []);

  const handleFavoritesClick = () => {
    Metrics.ga.sendEvent('Matcher', 'final go to favorites', 'button click');
    window.location = getPagePath('marketplace.favorites');
  };
  return (
    <div className={'matcher-final'}>
      <h2 className={'matcher-final--title'}>
        {trans('search.matcher.final.title')}
      </h2>
      <p className={'matcher-final--text'}>
        {trans('search.matcher.final.text')}
      </p>
      <Button
        onClick={handleFavoritesClick}
        fullWidth
        className={'matcher-final--button'}
        size="large"
      >
        {trans('search.matcher.final.button')}
      </Button>
    </div>
  );
};

export default Final;
